/**
 * Feature flags (build-time, `VITE_*` — baked in at `vite build`).
 *
 * VITE_FEATURE_HUGO — the HUGO Intelligent Assistant (Human Performance Barometer & REPS
 * Optimizer). Off in Beta-1: the Barometer is hidden from DREW (Tim, Aug 13 / D02 / D08) and
 * becomes HUGO's first page (Beta-1 plan P1-29 → P6-15). Set VITE_FEATURE_HUGO=true in
 * .env.local to see it in dev.
 */
export const FEATURE_HUGO = import.meta.env.VITE_FEATURE_HUGO === 'true';
